import type { CanvasSelectionType } from '@canvas-selector/appTypes'

export const availableSelectorTypes: CanvasSelectionType[] = [
  'canvas',
  'canvas-template',
  'section',
  'section-template',
]
